import { DateTime as a } from "luxon";
import { centsToDollar as m } from "./currency.js";
import { t as E } from "./toTitleCase-DdbgdWdW.js";
const c = (t) => {
  var e;
  return typeof t == "string" || typeof t == "number" ? t.toString() : Array.isArray(t) ? t.join(", ") : ((e = t == null ? void 0 : t.values) == null ? void 0 : e.join(", ")) || "";
}, d = /* @__PURE__ */ new Map([
  ["address", (t) => t],
  ["boolean", (t) => t],
  ["checkbox", (t) => t],
  [
    "date",
    (t) => a.fromISO(t).toFormat("MMMM d y")
  ],
  [
    "datetime",
    (t) => a.fromISO(t).toFormat("MMMM d y, h:mm a")
  ],
  ["dollar", (t) => m(t)],
  ["dropdown", (t) => c(t)],
  ["email", (t) => t],
  ["multiselect", (t) => c(t)],
  ["phonenumber", (t) => t],
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  ["number", (t) => t.toLocaleString()],
  ["textarea", (t) => t],
  ["textfield", (t) => t]
]), y = (t, e, n = ": ") => Object.entries(t).filter(([, o]) => !!o).map(([o, s]) => {
  const u = E(o), r = e == null ? void 0 : e.find((f) => f.name === o);
  if (!(r != null && r.type))
    return `${u}${n}${s}`;
  const i = d.get(r == null ? void 0 : r.type);
  return `${u}${n}${i ? i(s) : s}`;
});
function l(t) {
  return typeof t == "object" && t !== null && "message" in t && typeof t.message == "string";
}
function F(t) {
  if (!(typeof t == "object" && t !== null && "response" in t)) return !1;
  const { response: n } = t;
  if (!(typeof n == "object" && n !== null && "data" in n)) return !1;
  const { data: s } = n;
  return s ? typeof s.error == "string" : !1;
}
const p = (t) => typeof t == "string";
function g(t) {
  if (p(t)) return { message: t };
  if (F(t)) return { message: t.response.data.error };
  if (l(t)) return t;
  try {
    return new Error(JSON.stringify(t));
  } catch {
    return new Error(String(t));
  }
}
function Z(t, e) {
  return t ? g(t).message : e ?? "An error occurred";
}
const S = /^[\sa-zA-Z0-9-.,'\u00C0-\u00FF\u0100-\u017F\u0180-\u024F]{1,50}$/, R = /^[\sa-zA-Z0-9-.,'\u00C0-\u00FF\u0100-\u017F\u0180-\u024F]{1,50}$/, h = /^(\+1\s?)?(\(?\d{3}\)?[\s.-]?)?\d{3}[\s.-]?\d{4}$/, A = /^[\sa-zA-Z0-9/-:().,#;'°&\u00C0-\u00FF\u0100-\u017F\u0180-\u024F]{2,100}$/, M = /^[\sa-zA-Z0-9/-:().,#;'°&\u00C0-\u00FF\u0100-\u017F\u0180-\u024F]{2,100}$/, _ = /^[\sa-zA-Z0-9-().,'\u00C0-\u00FF\u0100-\u017F\u0180-\u024F]{2,50}$/, D = /^[\sa-zA-Z0-9/-:().,#;'°&\u00C0-\u00FF\u0100-\u017F\u0180-\u024F]{2,100}$/, $ = /^(?![-]+$)[\sa-zA-Z0-9-]{2,16}$/, C = /^US$/, N = /^\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/, P = {
  FIRST_NAME: S,
  LAST_NAME: R,
  ADDRESS1: A,
  ADDRESS2: M,
  CITY: _,
  STATE: D,
  ZIP_CODE: $,
  DOB: N,
  US_ONLY_REGEX: C,
  PHONE_NUMBER_REGEX: h
}, z = {
  paypal: { name: "PayPal" },
  venmo: { name: "Venmo" },
  bank: { name: "Bank Account" }
}, b = (t) => !!t.trim().length;
function T(t) {
  return t.split("-").join("");
}
const O = (t) => {
  let e = "";
  const n = T(t);
  return b(n.trim()) ? /^[0-9]+(-[0-9]+)*$/.test(n.trim()) ? n.length > 12 ? e = "* phone number must be less than 12 digits" : n.length < 10 && (e = "* phone number must be 10 digits") : e = "* phone number should only contain numbers" : e = "* phone number is required", e;
}, j = {
  phoneNumber: O
};
export {
  z as PAYMENT_ACCOUNTS_DICTIONARY,
  P as REGEX,
  j as Validator,
  Z as getErrorMessage,
  y as toCustomFieldArray
};
